export default "__VITE_ASSET__C4V9xZur__"